exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-table-tbody>tr>td,.ant-table-tbody>tr>th,.ant-table-thead>tr>th{text-align:center}.ant-spin-nested-loading>div>.ant-spin{position:absolute;display:flex}.ant-table-row-bold{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/dataTable.scss
// module id = 2151
// module chunks = 43